import React from 'react';
import { Phone } from 'lucide-react';
import { Button } from '@/components/ui/button';

const StickyCallButton = () => {
  return (
    <a
      href="tel:+4923139083687"
      className="sticky-call-button"
      data-testid="sticky-call-button"
      aria-label="24/7 Notruf anrufen"
    >
      <Button
        size="lg"
        className="rounded-full h-16 px-6 bg-[#e63946] hover:bg-[#d62828] text-white font-bold shadow-xl flex items-center space-x-3"
      >
        <Phone className="w-6 h-6 animate-pulse" />
        <div className="flex flex-col items-start leading-tight">
          <span className="text-xs font-normal">24/7 Notruf</span>
          <span className="text-base">0231 39083687</span>
        </div>
      </Button>
    </a>
  );
};

export default StickyCallButton;